<template>
  <div class="editPage">
    <qx-card :title="pageTitle">
      <BaseForm ref="baseForm" />
      <Settlement ref="settlement" />
    </qx-card>
    <SubBtnBox @sub="sub" />
  </div>
</template>

<script>
import BaseForm from './base';
import Settlement from './settlement';
import SubBtnBox from 'components/subBtnBox';
import {
  customerArchivesEdit,
  customerArchivesDetail,
} from 'api/archives';
import pageDataMixin from '@qx/mixin/pageData';
export default {
  mixins: [
    pageDataMixin,
  ],
  components: {
    BaseForm,
    Settlement,
    SubBtnBox,
  },
  data () {
    return {
      pageUrl: '/manage/archives/customer/archives/edit',
      formComponents: ['baseForm', 'settlement'],
      editParams: {
        type: 1,
      },
    };
  },
  computed: {
    detailParams () {
      return {
        customerId: this.$route.query.id,
      };
    },
  },
  methods: {
    detailApi: customerArchivesDetail,
    editApi: customerArchivesEdit,
  },
  async mounted () {
    await this.$refs.baseForm.getList();
    await this.$refs.settlement.getList();
    this.getData();
  },
};
</script>

<style scoped lang="scss">
</style>
